import React, { ReactNode } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { chartColors } from 'src/shared/constants/portfolio';

type PortfolioGaugeReChartProps = {
    sites: number;
    totalSites: number;
    chartData: {
        chartValue: number;
        startLabel: ReactNode;
        endLabel: ReactNode;
    };
    chartColor: string;
    category: string;
    summaryText: React.ReactNode;
};

const PortfolioGaugeChart = ({ sites, totalSites, chartData, chartColor, category, summaryText }: PortfolioGaugeReChartProps) => {
    const percentageSites = Math.round((sites / totalSites) * 100);

    const gaugeData = [
        { name: 'value', value: chartData.chartValue, color: chartColors[chartColor] },
        { name: 'remaining', value: 1 - chartData.chartValue, color: '#E5E7EB' },
    ];

    return (
        <div className='flex gap-4'>
            <div>
                <div className='flex flex-col gap-1'>
                    <div className='flex items-end mb-1'>
                        <div className='text-xs text-grey-80 text-right'>{chartData.startLabel}</div>
                        <div className='relative h-[80px] w-[160px]'>
                            <div className={`absolute text-[42px] top-7 w-full text-center text-${chartColor}-100`}>
                                {chartData.chartValue.toFixed(2)}
                            </div>
                            <ResponsiveContainer width='100%' height='100%'>
                                <PieChart>
                                    <Pie
                                        data={gaugeData}
                                        cx='50%'
                                        cy='100%'
                                        startAngle={180}
                                        endAngle={0}
                                        innerRadius={58}
                                        outerRadius={75}
                                        dataKey='value'
                                    >
                                        {gaugeData.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={entry.color} />
                                        ))}
                                    </Pie>
                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                        <div className='text-xs text-grey-80'>{chartData.endLabel}</div>
                    </div>
                </div>
                <div className={`text-2xl text-center text-${chartColor}-100`}>{category}</div>
                <div className='text-sm text-center text-grey-80 ${categorySubtitleClasses'>Average across portfolio</div>
            </div>

            <div className='bg-grey-20 w-[1px]'>&nbsp;</div>
            <div className='flex flex-col'>
                <div className='flex gap-2 mb-1 items-end'>
                    <span className='text-[42px] text-grey-80'>{sites}</span>
                    <span className='text-xl text-grey-80 pb-3'>({percentageSites}%)</span>
                </div>
                {summaryText}
                <div>
                    <span className='text-sm text-grey-80'>These carry the greatest </span>
                    <span className='text-sm text-grey-80 font-bold'>financial and reputational risk</span>
                </div>
            </div>
        </div>
    );
};

export default PortfolioGaugeChart;
